export const displayServiceTagsId = ['credit_card', 'barcode', 'parking']

export const displayAllServiceTagsId = [
  "credit_card",
  "barcode",
  "transportation_electronic_money",
  "debit_card",
  "parking",
  "drugstore",
  "barrier_free",
  "kids_space",
  "herbal_medicine",
  "single_packaged",
  "narcotic_prescription",
  "handicap_accessible",
  "multilingual",
  "my_number",
  "electronic_prescription",
]
